<template>
  <v-navigation-drawer
    v-model="showMenu"
    fixed
    temporary
  >
    <v-list expand>
      <v-list-item
        @click="goHome"
      >
        <v-list-item-action >
          <v-icon>fa-home</v-icon>
        </v-list-item-action>
        <v-list-item-title>Home</v-list-item-title>
      </v-list-item>

      <v-list-group
        v-for="(menuGroup, index) in menuGroups"
        :key="index"
        prepend-icon="fa-check"
        value="true"
      >
        <v-list-item slot="activator">
          <v-list-item-title>{{ menuGroup['menuGroupName_' + language] || menuGroup.menuGroupName_en }}</v-list-item-title>
        </v-list-item>
        <template
          v-for="(module, i) in menuGroupModules(menuGroup._id)"
        >
          <v-list-item
            v-if="module.moduleName && hasAnyAccess(module.moduleName)"
            :key="i"
            @click="openList(module.moduleName)"
          >
            <v-list-item-content class="text-left">
              <v-list-item-title v-text="module['namePlural_' + language] || module.namePlural_en || module.moduleName"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list-group>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import sharedComputed from './computed'

export default {
  name: 'LeftMenu',

  computed: {
    ...sharedComputed,

    ac () {
      return this.$store.getters.ac
    }
  },

  methods: {
    goHome () {
      this.$router.push('/')
    },

    menuGroupModules (groupId) {
      //if (!this.registeredModules) { return [] }
      // console.log('RR', this.registeredModules)
      let modules = Object.keys(this.modules).filter(moduleName => {
        let module = this.modules[moduleName]
        return module.menuGroup && module.menuGroup._id === groupId
      }).map(moduleName => this.modules[moduleName] )
      return modules
    },

    hasAnyAccess (moduleName) {
      // console.log('read', moduleName, this.ac.can('current').readAny(moduleName).granted)
      return this.ac.can('current').readAny(moduleName).granted ||
        this.ac.can('current').createAny(moduleName).granted ||
        this.ac.can('current').updateAny(moduleName).granted ||
        this.ac.can('current').deleteAny(moduleName).granted ||
        this.ac.can('current').readOwn(moduleName).granted ||
        this.ac.can('current').createOwn(moduleName).granted ||
        this.ac.can('current').updateOwn(moduleName).granted ||
        this.ac.can('current').deleteOwn(moduleName).granted
    },

    openList (moduleName) {
      this.$router.push('/' + moduleName)
    },

    translatedModule (moduleName) {
      if (this.$store.getters.translations &&
        this.$store.getters.translations.en &&
        this.$store.getters.translations.en[moduleName] &&
        this.$store.getters.translations.en[moduleName].title
      ) {
        return this.$store.getters.translations.en[moduleName].title
      }
      return moduleName
    },

  }
}
</script>
